$(document).ready(function() {
    let latitude = 0;
    let longitude = 0;

    // let queue = [];
    // let isProcessing = false;

    // function processQueue() {
    //     if (queue.length > 0 && !isProcessing) {
    //         isProcessing = true;
    //         console.log("started");
    //         // setTimeout(() => {
    //         //     Celestial.stop(true)
    //         //     console.log("done")
    //         //     isProcessing = false;
    //         //     processQueue();
    //         // }, 10);
    //         const currentInput = queue.shift();
    //         // Celestial.stop()
    //         Celestial.rotate(currentInput);
    //     }
    // }

    // Celestial.addCallback(function() {
    //     clearTimeout(callbackTimeout);
        
    //     callbackTimeout = setTimeout(() => {
    //         isProcessing = false;
    //         console.log('done');
    //         processQueue();
    //     }, 100);
    // })

    // function addToQueue(input) {
    //     queue.push(input);
    //     processQueue();
    // }

    $('.bp-star-coordinates').on('change', function(){
        const coordinates = $(this).val().split(',');
        if(coordinates.length == 2) {
            latitude = coordinates[0];
            longitude = coordinates[1];
        }
    });

    function s3Upload(blob) {
        const response = new Promise (function (resolve, reject) {
            var bucketName = "newbornposter";
            var bucketRegion = "us-east-1";
            var IdentityPoolId = "us-east-1:f9ca8273-bd68-474e-a0b3-5fc3e4063d87";
            var image_url = "";
        
            AWS.config.update({
            region: bucketRegion,
            credentials: new AWS.CognitoIdentityCredentials({ IdentityPoolId: IdentityPoolId })
            });

            var s3 = new AWS.S3({
            apiVersion: '2012-10-17',
            params: {Bucket: bucketName}
            });

            var params = {
                Key: Date.now() + "." + blob.type.split("/")[1],
                Body: blob,
                ContentType: blob.type,
                ACL: 'public-read'
            }

            s3.upload(params, function(err, data) {
                if(err) {
                    console.log("checking error", err);
                    reject(err);
                } else {
                    image_url = data.Location;
                    resolve(image_url);
                }
            });
        })

        return response;
    }

    function getPoint(lat, long, date) {
        lat = Number(lat),
        long = Number(long);
        let point = Celestial.getPoint(Celestial.horizontal.inverse(date, [90, 0], [lat, long]), "equatorial");
        
        point[2] = 0;
        return point
    }

    function getStringDate(date, format) {
        return format.replace('[day]', parseInt(date[0])).replace('[day_formatted]', date[0]).replace('[month]', date[1]).replace('[year]', date[2])
    }

    function convertToDate(dateString) {
        const datePart = dateString.split(' ')[0] || '01-01-2024';
        let timePart = dateString.split(' ')[1] || '00:00';
        let timeunit = ""
        if(timePart.includes('AM')){
            timeunit = "am";
        }
        if(timePart.includes('PM')){
            timeunit = "pm";
        }
        timePart = timePart.replace("AM", "").replace("PM", "");
        const [day, month, year] = datePart.split('-');
        let [hours, minutes] = timePart.split(':');

        if (timeunit === "pm" && hours !== "12" && hours !== "") {
            hours = parseInt(hours);
            hours += 12;
        } else if (timeunit === "am" && hours === "12" && hours !== "") {
            hours = parseInt(hours);
            hours = 0; // Midnight case
        }

        let date = new Date(Date.UTC(year, month - 1, day, hours, minutes, 0, 0));
        return date
    }

    function getLayoutClasses(index, classNames) {
        var current_classes = classNames.split(" "), classes_to_remove = []; 
        
        $.each(current_classes, function (index, class_name) {
          if (/^layout-.*/.test(class_name)) {classes_to_remove.push(class_name);}
        });
    
        return classes_to_remove.join(" ");
    }

    $('.bp-layout-radio').on('change', function(){
        let layout = $(this).attr("data-layout");
        let val = $(this).val();

        $('.bp-template').val(val);

        $('.birthposter-template').removeClass(getLayoutClasses);
        $('.birthposter-template').addClass(`layout-${layout}`);

        $('.hidden-preview').removeClass(getLayoutClasses);
        $('.hidden-preview').addClass(`layout-${layout}`);
    });

    $('.bp-constellation-radio').on('change', function(){
        let constellation = $(this).val();
        let container_size = $('.bp-poster-preview').width();
        let scale_factor = container_size / 250;
        let constellation_color = $('.bp-background-radio:checked').attr('data-constellation')

        if(Celestial) {
            if(constellation == "yes") {
                Celestial.apply({
                    "constellations": {
                        "names": false,
                        "nameStyle": {
                            "display": false,
                            "opacity": 0
                        },
                        "show": true,
                        "lineStyle": {
                            "stroke": [
                                constellation_color,
                                constellation_color,
                                constellation_color
                            ],
                            "width": [
                                0.2 * scale_factor,
                                0.2 * scale_factor,
                                0.2 * scale_factor
                            ],
                            "opacity": [
                            1,
                            1,
                            1
                            ]
                        }
                    }
                })
    
            }
            else {
                Celestial.apply({
                    "constellations": {
                        "names": false,
                        "nameStyle": {
                            "display": false,
                            "opacity": 0
                        },
                        "show": true,
                        "lineStyle": {
                            "stroke": [
                                constellation_color,
                                constellation_color,
                                constellation_color
                            ],
                            "width": [
                                0.2 * scale_factor,
                                0.2 * scale_factor,
                                0.2 * scale_factor
                            ],
                            "opacity": [
                            0,
                            0,
                            0
                            ]
                        }
                    }
                })
    
            }
        }
    });

    $('#bp-star-text1').on('input change', function(){
        let text1 = $(this).val();

        $(this).val(text1.toUpperCase());
        $('.bp-poster-headline .bp-stars-text1').text(text1.toUpperCase())
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-headline');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('#bp-stars-over, #bp-star-text2').on('input change', function(){
        let text2 = $(this).val();

        let stars_over = $('#bp-stars-over, #bp-star-text2')

        $(this).val(text2.toUpperCase());
        $('.bp-poster-headline .bp-stars-text2').text(text2.toUpperCase())

        stars_over.each((index, item) => {
            if(item != this) item.value = text2.toUpperCase();
        })
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-headline');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('#bp-simple-plats').on('input change', function(){
        let plats = $(this).val();

        $(this).val(plats.toUpperCase());
        $('.bp-poster-subheading .bp-plats-text').text(plats.toUpperCase())

        $('.bp-plats input').val(plats.toUpperCase())
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-subheading');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('#bp-extra-text-input').on('input change', function(){
        let extra = $(this).val();

        $(this).val(extra.toUpperCase());
        $('.bp-poster-subheading .bp-extra-text').text(extra.toUpperCase())
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-subheading');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('.bp-birth-day-selector').on('change', function(){
        let day = $(this).val();
        day = parseInt(day).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        let date = $(`.birth-date`).val();
        date = date.split("-");
        date[0] = day;
        date = date.join("-");
        $(`.birth-date`).val(date);
        $(`.birth-date`).change();
    });

    $('.bp-birth-month-selector').on('change', function(){
        let month = $(this).find(":selected").attr('data-month');
        let date = $(`.birth-date`).val();
        date = date.split("-");
        date[1] = month;
        date = date.join("-");
        $(`.birth-date`).val(date);
        $(`.birth-date`).change();
    });

    $('.bp-birth-year-selector').on('change', function(){
        let year = $(this).val();
        let date = $(`.birth-date`).val();
        date = date.split("-");
        date[2] = year;
        date = date.join("-");
        $(`.birth-date`).val(date);
        $(`.birth-date`).change();
    });

    $('.birth-date').on('change', function(event){
        let date = $(this).val();
        let time = $('.birth-time').val()
        let date_object = convertToDate(`${date} ${time}`);
        let format = $(this).attr('data-format');
        date = date.split("-");

        $(`.bp-birth-day-selector`).val(parseInt(date[0]))
        $(`.bp-birth-month-selector`).val($(`.bp-birth-month-selector`).find(`[data-month=${date[1]}]`).val());
        $(`.bp-birth-year-selector`).val(date[2])

        date[1] = $(`.bp-birth-month-selector`).find(`[data-month=${date[1]}]`).val().toUpperCase();
        date = getStringDate(date, format);
        $(`.bp-date`).text(`${date}`);

        clearTimeout(starPosterCallbackTimeout);

        let debouncing_time = 500;
        if(localStorage.getItem("localStorageWork"))
            debouncing_time = 1000;

        if(typeof svg_changed !== 'undefined') {
            svg_changed = true;
        }
        starPosterCallbackTimeout = setTimeout(() => {
            Celestial.rotate({
                center: getPoint(latitude, longitude, date_object),
                horizon: 0
            });
        }, debouncing_time);
    });

    $('.bp-hours-input').on('input change', function(){
        let hours = $(this).val();
        let max = $(this).attr('max');
        let ext = $(`.birth-time`).attr("data-ext").replaceAll(" ", "" ).replaceAll(".", "" );

        let prev = $(this).attr('data-prev');
        
        if(parseFloat(hours) > parseFloat(max)) {
            $(this).val(prev)
            return
        } 

        $(this).attr('data-prev', $(this).val())
        
        // hours = $(this).val();
        // hours_int = parseInt(hours);
        // if(hours_int) {
        //     let formatted_number = hours_int.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        //     $(this).val(formatted_number)
        // }

        hours = $(this).val();
        if(hours.length > 1) {
            $(`.bp-minutes-input`).focus();
        }

        hours = $(this).val();
        let time = $(`.birth-time`).val();
        time = time.replace("AM", "").replace("PM", "");
        if(time){
            time = time.split(":")
            time[0] = hours
            time = time.join(":")
            $(`.birth-time`).val(time + ext);
            $(`.birth-time`).change();
        }
        else{
            $(`.birth-time`).val(`${hours}:`);
            $(`.birth-time`).change();
        }
    });

    $('.bp-minutes-input').on('input change', function(){
        let minutes = $(this).val();
        let max = $(this).attr('max');
        let ext = $(`.birth-time`).attr("data-ext").replaceAll(" ", "" ).replaceAll(".", "" );

        let prev = $(this).attr('data-prev');

        if(parseFloat(minutes) > parseFloat(max)) {
            $(this).val(prev)
            return
        } 
        
        $(this).attr('data-prev', $(this).val())

        // minutes = $(this).val();
        // minutes_int = parseInt(minutes);
        // if(minutes_int) {
        //     let formatted_number = minutes_int.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        //     $(this).val(formatted_number)
        // }

        minutes = $(this).val();
        let time = $(`.birth-time`).val();
        time = time.replace("AM", "").replace("PM", "");
        if(time){
            time = time.split(":")
            time[1] = minutes
            time = time.join(":")
            $(`.birth-time`).val(time + ext);
            $(`.birth-time`).change();
        }
        else{
            $(`.birth-time`).val(`:${minutes}`);
            $(`.birth-time`).change();
        }
    });

    $('.bp-time-unit').on('change', function(){
        let val = $(this).val();

        let hrs = parseInt($(`.bp-hours-input`).val())
        if(val) {
            $(`.bp-hours-input`).attr("max", 12);
            $(`.birth-time`).attr("data-ext", ` ${val}`)
            if(hrs > 12) {
                $(`.bp-hours-input`).val(hrs - 12);
            }
        }
        else {
            $(`.birth-time`).attr("data-ext", ``)
            $(`.bp-hours-input`).attr("max", 23);
        }
        $(`.bp-hours-input`).change()
    });

    $('.birth-time').on('change', function(event){
        let time = $(this).val();
        let only_time = time.replace("AM", "").replace("PM", "");
        let ext = "";
        if(time.includes("AM")) {
            $(`.bp-hours-input`).attr("max", 12);
            $(`.bp-time-unit`).val("A.M.");
            ext = " A.M.";
        }
        else if (time.includes("PM")) {
            $(`.bp-hours-input`).attr("max", 12);
            $(`.bp-time-unit`).val("P.M.");
            ext = " P.M."
        }

        $(this).attr("data-ext", ext);
        let time_arr = only_time.split(":");

        if(time_arr[0].length > 0 && time_arr[1].length > 0 ) {
            $(`.bp-hours-input`).val(time_arr[0]);
            $(`.bp-minutes-input`).val(time_arr[1]);
            $(`.bp-time`).text(only_time + ext);
        }
        else {
            if(time_arr[0].length == 0){
                $(`.bp-hours-input`).val('');
            }
            if(time_arr[1].length == 0){
                $(`.bp-minutes-input`).val('');
            }
            $(`.bp-time`).text('');
        }

        let date = $('.birth-date').val();
        let date_object = convertToDate(`${date} ${time}`);

        //this is debouncing approach. The rotation only starts if the time has not been changed within 1 second
        clearTimeout(starPosterCallbackTimeout);

        let debouncing_time = 500;
        if(localStorage.getItem("localStorageWork"))
            debouncing_time = 1000;
        
        if(typeof svg_changed !== 'undefined') {
            svg_changed = true;
        }
        starPosterCallbackTimeout = setTimeout(() => {
            Celestial.rotate({
                center: getPoint(latitude, longitude, date_object),
                horizon: 0
            });
        }, debouncing_time);
    });


    const geocoderElement = new mapboxsearch.MapboxGeocoder()

    geocoderElement.accessToken = 'pk.eyJ1IjoidGhlYmlydGhwb3N0ZXIiLCJhIjoiY2s4ZmY2bWY1MDBhbjNscGtsZGF4cWtxbyJ9.ov1e8hiGtyKZpt0F1aFIYQ'

    geocoderElement.options = {
    language: 'en',
    types: 'region,district,place,locality'
    }
    geocoderElement.placeholder = "SEARCH"

    geocoderElement.theme = {
        variables: {
            boxShadow: 'unset',
            border: "1px solid #c7c7c7",
            borderRadius: "5px",
            minWidth: "200px"
        }
    }

    let plats_cont = document.querySelector('.bp-plats .bp-input-block');
    plats_cont.innerHTML = '';
    plats_cont.appendChild(geocoderElement);
    geocoderElement.addEventListener('retrieve', (e) => {
        const coordinates = e.detail.geometry.coordinates;
        const address = e.detail.properties.full_address
        latitude = coordinates[0];
        longitude = coordinates[1];

        // localStorage.setItem('coordinates', coordinates);

        $('.bp-star-coordinates').val(coordinates);
        $('.bp-star-coordinates').change();

        let date = $('.birth-date').val();
        let time = $('.birth-time').val();
        let date_object = convertToDate(`${date} ${time}`);

        $('#bp-simple-plats').val(address);
        $('#bp-simple-plats').change();

        // addToQueue({
        //     center: getPoint(latitude, longitude, date_object),
        //     horizon: 0
        // })
        if(typeof svg_changed !== 'undefined') {
            svg_changed = true;
        }
        Celestial.rotate({
            center: getPoint(latitude, longitude, date_object),
            horizon: 0
        });
    });

    let container_size = $('.bp-poster-preview').width();
    let scale_factor = container_size / 250;

    // console.log(container_size)

    var config = {
        container: "celestial-map",
        datapath: "https://cdn.shopify.com/s/files/1/0803/2777/0452/files/",
        width: 0,
        center: null,
        "projection": "airy",
        "transform": "equatorial",
        "horizon": 0,
        "form": false,
        "interactive": false,
        "controls": false,
        "follow": "center",
        "dsos": {
          "show": false
        },
        "planets": {
          "show": false
        },
        "mw": {
          "show": false
        },
        "stars": {
          "limit": 5.5,
          "size": 2 * scale_factor,
          "exponent": -0.25,
          "colors": false,
          "designation": false,
          "propername": false,
          "style": {
            "fill": "#fff",
            "opacity": 1
          }
        },
        "constellations": {
          "names": false,
          "nameStyle": {
            "display": false,
            "opacity": 0
          },
          "show": true,
          "lineStyle": {
            "stroke": [
              "#fff",
              "#fff",
              "#fff"
            ],
            "width": [
                0.2 * scale_factor,
                0.2 * scale_factor,
                0.2 * scale_factor
            ],
            "opacity": [
              1,
              1,
              1
            ]
          }
        },
        "background": {
          "width": 0,
          "fill": "#32384b"
        },
        "lines": {
          "graticule": {
            "show": false,
            "stroke": "#909090",
            "width": 0.6 * scale_factor
          },
          "equatorial": {
            "show": false,
            "stroke": "#909090",
            "width": 1.5 * scale_factor
          },
          "ecliptic": {
            "show": false
          }
        }
    }
    
    Celestial.display(config);

    Celestial.uploadSVG = function () {
        return new Promise((resolve, reject) => {
            Celestial.exportSVG(function (svg) { 
                if (!svg) {
                    reject(false);
                    return;
                }
    
                let blob = new Blob([svg], {type:"image/svg"});
    
                s3Upload(blob)
                    .then(result => resolve(result)) 
                    .catch(error => reject(false));
            });
        });
    }
});



// var config = { 
//     width: 0,          
//     projection: "airy",   
//     transform: "equatorial",
//     center: null, 
//     orientationfixed: true,  // Keep orientation angle the same as center[2]
//     geopos: null,       // optional initial geographic position [lat,lon] in degrees, 
//                         // overrides center
//     follow: "zenith",   // on which coordinates to center the map, default: zenith, if location enabled, 
//                         // otherwise center
//     zoomlevel: 1,    // initial zoom level 0...zoomextend; 0|null = default, 1 = 100%, 0 < x <= zoomextend
//     zoomextend: 10,     // maximum zoom level
//     adaptable: false,    // Sizes are increased with higher zoom-levels
//     interactive: false,  // Enable zooming and rotation with mousewheel and dragging
//     form: false,         // Display form for interactive settings. Needs a div with
//                         // id="celestial-form", created automatically if not present
//     location: false,    // Display location settings. Deprecated, use formFields below
//     formFields: {"location": true,  // Set visiblity for each group of fields with the respective id
//                  "general": true,  
//                  "stars": true,  
//                  "dsos": true,  
//                  "constellations": true,  
//                  "lines": true,  
//                  "other": true,  
//                  "download": false},  
//     advanced: true,     // Display fewer form fields if false 
//     daterange: [],      // Calender date range; null: displaydate-+10; [n<100]: displaydate-+n; [yr]: yr-+10; 
//                         // [yr, n<100]: [yr-n, yr+n]; [yr0, yr1]  
//     controls: true,     // Display zoom controls
//     lang: "",           // Global language override for names, any name setting that has the chosen language available
//                         // Default: desig or empty string for designations, other languages as used anywhere else
//     culture: "",        // Source of constellations and star names, default "iau", other: "cn" Traditional Chinese
//     container: "celestial-map",   // ID of parent element, e.g. div, null = html-body
//     datapath: "https://cdn.shopify.com/s/files/1/0803/2777/0452/files/",  // Path/URL to data files, empty = subfolder 'data'
//     stars: {
//       show: true,    // Show stars
//       limit: 6,      // Show only stars brighter than limit magnitude
//       colors: true,  // Show stars in spectral colors, if not use default color
//       style: { fill: "#ffffff", opacity: 1 }, // Default style for stars
//       designation: true, // Show star names (Bayer, Flamsteed, Variable star, Gliese or designation, 
//                          // i.e. whichever of the previous applies first); may vary with culture setting
//       designationType: "desig",  // Which kind of name is displayed as designation (fieldname in starnames.json)
//       designationStyle: { fill: "#ddddbb", font: "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif", align: "left", baseline: "top" },
//       designationLimit: 2.5,  // Show only names for stars brighter than nameLimit
//       propername: false,   // Show proper name (if present)
//       propernameType: "name", // Languge for proper name, default IAU name; may vary with culture setting 
//                               // (see list below of languages codes available for stars)
//       propernameStyle: { fill: "#ddddbb", font: "13px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif", align: "right", baseline: "bottom" },
//       propernameLimit: 1.5,  // Show proper names for stars brighter than propernameLimit
//       size: 7,       // Maximum size (radius) of star circle in pixels
//       exponent: -0.28, // Scale exponent for star size, larger = more linear
//       data: 'stars.6.json' // Data source for stellar data, 
//                            // number indicates limit magnitude
//     },
//     dsos: {
//       show: true,    // Show Deep Space Objects 
//       limit: 6,      // Show only DSOs brighter than limit magnitude
//       colors: true,  // // Show DSOs in symbol colors if true, use style setting below if false
//       style: { fill: "#cccccc", stroke: "#cccccc", width: 2, opacity: 1 }, // Default style for dsos
//       names: false,   // Show DSO names
//       namesType: "name",  // Type of DSO ('desig' or language) name shown
//                           // (see list below for languages codes available for dsos)
//       nameStyle: { fill: "#cccccc", font: "11px Helvetica, Arial, serif", 
//                    align: "left", baseline: "top" }, // Style for DSO names
//       nameLimit: 6,  // Show only names for DSOs brighter than namelimit
//       size: null,    // Optional seperate scale size for DSOs, null = stars.size
//       exponent: 1.4, // Scale exponent for DSO size, larger = more non-linear
//       data: 'dsos.bright.json', // Data source for DSOs, 
//                                 // opt. number indicates limit magnitude
//       symbols: {  //DSO symbol styles, 'stroke'-parameter present = outline
//         gg: {shape: "circle", fill: "#ff0000"},          // Galaxy cluster
//         g:  {shape: "ellipse", fill: "#ff0000"},         // Generic galaxy
//         s:  {shape: "ellipse", fill: "#ff0000"},         // Spiral galaxy
//         s0: {shape: "ellipse", fill: "#ff0000"},         // Lenticular galaxy
//         sd: {shape: "ellipse", fill: "#ff0000"},         // Dwarf galaxy
//         e:  {shape: "ellipse", fill: "#ff0000"},         // Elliptical galaxy
//         i:  {shape: "ellipse", fill: "#ff0000"},         // Irregular galaxy
//         oc: {shape: "circle", fill: "#ffcc00", 
//              stroke: "#ffcc00", width: 1.5},             // Open cluster
//         gc: {shape: "circle", fill: "#ff9900"},          // Globular cluster
//         en: {shape: "square", fill: "#ff00cc"},          // Emission nebula
//         bn: {shape: "square", fill: "#ff00cc", 
//              stroke: "#ff00cc", width: 2},               // Generic bright nebula
//         sfr:{shape: "square", fill: "#cc00ff", 
//              stroke: "#cc00ff", width: 2},               // Star forming region
//         rn: {shape: "square", fill: "#00ooff"},          // Reflection nebula
//         pn: {shape: "diamond", fill: "#00cccc"},         // Planetary nebula 
//         snr:{shape: "diamond", fill: "#ff00cc"},         // Supernova remnant
//         dn: {shape: "square", fill: "#999999", 
//              stroke: "#999999", width: 2},               // Dark nebula grey
//         pos:{shape: "marker", fill: "#cccccc", 
//              stroke: "#cccccc", width: 1.5}              // Generic marker
//       }
//     },
//     planets: {  //Show planet locations, if date-time is set
//       show: false,
//       // List of all objects to show
//       which: ["sol", "mer", "ven", "ter", "lun", "mar", "jup", "sat", "ura", "nep"],
//       // Font styles for planetary symbols
//       symbols: {  // Character and color for each symbol in 'which' above (simple circle: \u25cf), optional size override for Sun & Moon
//         "sol": {symbol: "\u2609", letter:"Su", fill: "#ffff00", size:""},
//         "mer": {symbol: "\u263f", letter:"Me", fill: "#cccccc"},
//         "ven": {symbol: "\u2640", letter:"V", fill: "#eeeecc"},
//         "ter": {symbol: "\u2295", letter:"T", fill: "#00ccff"},
//         "lun": {symbol: "\u25cf", letter:"L", fill: "#ffffff", size:""}, // overridden by generated crecent, except letter & size
//         "mar": {symbol: "\u2642", letter:"Ma", fill: "#ff6600"},
//         "cer": {symbol: "\u26b3", letter:"C", fill: "#cccccc"},
//         "ves": {symbol: "\u26b6", letter:"Ma", fill: "#cccccc"},
//         "jup": {symbol: "\u2643", letter:"J", fill: "#ffaa33"},
//         "sat": {symbol: "\u2644", letter:"Sa", fill: "#ffdd66"},
//         "ura": {symbol: "\u2645", letter:"U", fill: "#66ccff"},
//         "nep": {symbol: "\u2646", letter:"N", fill: "#6666ff"},
//         "plu": {symbol: "\u2647", letter:"P", fill: "#aaaaaa"},
//         "eri": {symbol: "\u26aa", letter:"E", fill: "#eeeeee"}
//       },
//       symbolStyle: { fill: "#00ccff", font: "bold 17px 'Lucida Sans Unicode', Consolas, sans-serif", 
//                align: "center", baseline: "middle" },
//       symbolType: "symbol",  // Type of planet symbol: 'symbol' graphic planet sign, 'disk' filled circle scaled by magnitude
//                              // 'letter': 1 or 2 letters S Me V L Ma J S U N     
//       names: false,          // Show name in nameType language next to symbol
//       nameStyle: { fill: "#00ccff", font: "14px 'Lucida Sans Unicode', Consolas, sans-serif", align: "right", baseline: "top" },
//       namesType: "desig"     // Language of planet name (see list below of language codes available for planets), 
//                              // or desig = 3-letter designation
//     },
//     constellations: {
//       names: false,      // Show constellation names 
//       namesType: "iau", // Type of name Latin (iau, default), 3 letter designation (desig) or other language (see list below)
//       nameStyle: { fill:"#cccc99", align: "center", baseline: "middle", 
//                    font: ["14px Helvetica, Arial, sans-serif",  // Style for constellations
//                           "12px Helvetica, Arial, sans-serif",  // Different fonts for diff.
//                           "11px Helvetica, Arial, sans-serif"]},// ranked constellations
//       lines: true,   // Show constellation lines, style below
//       lineStyle: { stroke: "#cccccc", width: 1, opacity: 0.6 }, 
//       bounds: false, // Show constellation boundaries, style below
//       boundStyle: { stroke: "#cccc00", width: 0.5, opacity: 0.8, dash: [2, 4] }
//     },  
//     mw: {
//       show: true,     // Show Milky Way as filled multi-polygon outlines 
//       style: { fill: "#ffffff", opacity: 0.15 }  // Style for MW layers
//     },
//     lines: {  // Display & styles for graticule & some planes
//       graticule: { show: true, stroke: "#cccccc", width: 0.6, opacity: 0.8,   
//         // grid values: "outline", "center", or [lat,...] specific position
//         lon: {pos: [""], fill: "#eee", font: "10px Helvetica, Arial, sans-serif"}, 
//         // grid values: "outline", "center", or [lon,...] specific position
//         lat: {pos: [""], fill: "#eee", font: "10px Helvetica, Arial, sans-serif"}},    
//       equatorial: { show: true, stroke: "#aaaaaa", width: 1.3, opacity: 0.7 },  
//       ecliptic: { show: true, stroke: "#66cc66", width: 1.3, opacity: 0.7 },     
//       galactic: { show: false, stroke: "#cc6666", width: 1.3, opacity: 0.7 },    
//       supergalactic: { show: false, stroke: "#cc66cc", width: 1.3, opacity: 0.7 }
//     },
//     background: {        // Background style
//       fill: "#000000",   // Area fill
//       opacity: 1, 
//       stroke: "#000000", // Outline
//       width: 1.5
//     }, 
//     horizon: {  //Show horizon marker, if location is set and map projection is all-sky
//       show: false, 
//       stroke: "#cccccc", // Line
//       width: 1.0, 
//       fill: "#000000",   // Area below horizon
//       opacity: 0.5
//     },  
//     daylight: {  //Show day sky as a gradient, if location is set and map projection is hemispheric
//       show: false
//     }
// };